<div [ngSwitch]="type">
  <div *ngSwitchCase="'basic'">
    <p-dropdown [options]="options" [(ngModel)]="initialOption" optionLabel="name" [attr.placeholder]="placeholder" (onChange)="onValueChange($event)"></p-dropdown>
  </div>
  <div *ngSwitchCase="'flags'">
    <p-dropdown
      [options]="options"
      [(ngModel)]="initialOption"
      optionLabel="name"
      [attr.placeholder]="placeholder"
      (onChange)="onValueChange($event)"
      [scrollHeight]="'290px'"
    >
      <ng-template pTemplate="selectedItem">
        <div class="flex align-items-center gap-2" *ngIf="initialOption">
          <div class="icon" *ngIf="initialOption.icon"><i [className]="(initialOption.icon.includes(' ') ? '' : 'fas ') + initialOption.icon" [style]="'color:' + initialOption.color + ';'"></i></div>
        </div>
      </ng-template>
      <ng-template let-option pTemplate="item">
        <div class="flex align-items-center gap-2">
          <div class="icon" *ngIf="option.icon"><i [className]="(option.icon.includes(' ') ? '' : 'fas ') + option.icon" [style]="'color:' + option.color + ';'"></i></div>
        </div>
      </ng-template>
    </p-dropdown>
  </div>
</div>
